module.exports = __webpack_public_path__ + "static/img/13.737d94c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/13.svg
// module id = b+zt
// module chunks = 0